<template>
  <div :class="['text-input', { 'no-label-input': !showLabelStyle }]">
    <span v-if="showLabelName" class="label">{{ fontStyle.labelName }}</span>
    <div :class="['input-wrap', !isShowText && 'disable']">
      <textarea
        v-if="fontStyle.isMainTitle"
        cols="2"
        required="required"
        :placeholder="`${minLength}~${maxLength}个字`"
        :class="[
          'main-title',
          isShowText &&
            fontStyle.text &&
            (fontStyle.text.length < minLength || fontStyle.text.length > maxLength) &&
            'error',
          !isShowText && 'disable',
        ]"
        v-model.trim="fontStyle.text"
        @input="onInput($event, fontStyle)"
      ></textarea>
      <input
        v-else
        type="text"
        :minlength="minLength"
        :maxlength="maxLength"
        :placeholder="`${minLength}~${maxLength}个字`"
        :class="[
          isShowText &&
            fontStyle.text &&
            (fontStyle.text.length < minLength || fontStyle.text.length > maxLength) &&
            'error',
          !isShowText && 'disable',
        ]"
        :disabled="!isShowText"
        v-model.trim="fontStyle.text"
      />
      <span class="text-num">{{ textLength }}</span>
      <span class="prompt" v-show="fontStyle.text && fontStyle.text.length > 0">
        输入{{ minLength }} ~ {{ fontStyle.textMaxLength }}个字
      </span>
    </div>
    <div v-if="showLabelStyle" class="text-style">
      <div v-if="fontStyle.isLabelStyle" :class="['select', !isShowText && 'disable']" @click.stop="showLableStyleMenu">
        <span
          class="label-style-name"
          :style="{
            color: `${(isShowText && themeColor && themeColor.split(',')[0]) || '#B6B8BB'}`,
          }"
          >{{ fontStyle.labelStyle || "请选择" }}</span
        >
        <span v-if="fontStyle.labelStyle" class="style_exmp" :style="genLabelStyle(fontStyle.labelStyle)"></span>
        <i
          :class="['el-input__icon', 'el-icon-arrow-up', isShowLableStyleMenu && 'on']"
          :style="{ color: isShowText ? `${themeColor}` : '#B6B8BB' }"
        ></i>
      </div>
      <el-switch
        v-if="!fontStyle.isMainTitle"
        :value="isShowText"
        active-color="#3F69F9"
        inactive-color="#D6DBE0"
        @change="changeInputUsable"
      ></el-switch>
      <div v-if="fontStyle.isLabelStyle" :class="['select-dropdown', isShowLableStyleMenu && 'on']">
        <div
          class="option"
          v-for="optionItem in Object.values(labelStyleMenu)"
          :key="optionItem.id"
          @click="selectLabelStyle(optionItem)"
        >
          <span class="option_name">{{ optionItem.name }}</span>
          <span class="style_exmp" :style="genLabelStyle(optionItem.name)"></span>
          <i v-if="optionItem.name === fontStyle.labelStyle" class="iconfont icon-gouxuan"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLabelStyleMenu } from "@/assets/scripts/common.js";
import { setMainTitle } from "./../js/cover-feature.js";
export default {
  name: "CoverInput",
  props: {
    themeColor: {
      type: String,
      require: false,
      default: "#ccc",
    },
    fontStyle: {
      type: Object,
      require: true,
    },
    // 显示标签名
    showLabelName: {
      type: Boolean,
      default: true,
    },
    // 显示标签样式
    showLabelStyle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // label样式菜单是否显示
      isShowLableStyleMenu: false,
      // label的样式菜单
      labelStyleMenu: {},
      // 是否非法输入
      illegalInput: false,
      prevText: "",
      // 文字长度
      textLength: 0,
    };
  },
  computed: {
    maxLength() {
      const max = this.fontStyle.textMaxLength;
      if (this.fontStyle.isMainTitle && /\n/g.test(this.fontStyle.text)) {
        return max + 1;
      }
      return max;
    },
    minLength() {
      return this.fontStyle.textMinLength;
    },
    isShowText() {
      return this.fontStyle.isShowText;
    },
  },
  watch: {
    themeColor: {
      handler(val) {
        // label样式菜单
        this.labelStyleMenu = getLabelStyleMenu(val);
      },
      immediate: true,
    },
    fontStyle: {
      handler(val) {
        // 文字长度
        let len = (val.text && val.text.length) || 0;
        if (val.isMainTitle && /\n/g.test(val.text)) {
          len -= 1;
        }
        this.textLength = len;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    document.addEventListener("click", () => {
      this.isShowLableStyleMenu = false;
    });
    this.prevText = this.fontStyle.text;
  },
  methods: {
    genLabelStyle(styleName) {
      const style = this.labelStyleMenu[parseInt(styleName.substr(-1))].style;
      style["border"] && (style.border = "1px solid #D6DBE0");
      return style;
    },
    // 显示label样式下拉框
    showLableStyleMenu() {
      this.isShowText && (this.isShowLableStyleMenu = !this.isShowLableStyleMenu);
    },
    // 主标题输入监听
    onInput(event, textMap) {
      // 换行处理
      const text = setMainTitle(textMap, this.prevText);
      this.$emit("mainInput", textMap, text);
      this.prevText = text;
    },
    // 切换输入框是否可用
    changeInputUsable() {
      this.$emit("changeInputUsable", this.fontStyle);
    },
    // 选择label样式
    selectLabelStyle(optionItem) {
      this.$emit("changeLabelStyle", {
        lineIndex: this.fontStyle.lineIndex,
        labelData: optionItem,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-input {
  position: relative;
  display: block;
  padding-bottom: 32px;
  font-size: 16px;
  color: #6d7278;
  .label {
    position: relative;
    display: inline-block;
    width: 80px;
    padding: 9px;
  }
  .input-wrap {
    vertical-align: top;
    position: relative;
    display: inline-block;
    .main-title {
      width: 375px;
      height: 84px;
      border: 1px solid #6d7278;
      color: #183b56;
      padding: 11px 15px 15px;
      font-size: 16px;
      border-radius: 4px;
      resize: none;
    }
    .prompt {
      position: absolute;
      left: 0px;
      bottom: -20px;
      font-size: 12px;
    }
    .text-num {
      position: absolute;
      top: 13px;
      right: 15px;
      width: 16px;
      font-size: 12px;
      color: #ccc;
      text-align: right;
    }
    .require {
      &::before {
        position: absolute;
        top: 8px;
        left: -2px;
        content: "*";
        color: red;
        display: inline-block;
      }
    }
    input {
      width: 375px;
      height: 42px;
      padding-left: 15px;
      font-size: 16px;
      border: 1px solid #6d7278;
      border-radius: 4px 0 0 4px;
      color: #183b56;
      &.disable {
        // border-color: #d6dbe0;
        background: #f3f3f3;
        color: #aaa;
      }
    }
    .error {
      color: red;
      border-color: red !important;
    }
  }

  .text-style {
    position: relative;
    display: inline-flex;
    vertical-align: top;
    height: 42px;
    align-items: center;
    input {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    .checkbox_wrap {
      display: inline-block;
      position: relative;
      padding: 10px 12px 10px 0;
      cursor: pointer;
      .checkbox {
        border: 1px solid #3f69f9;
        border-radius: 2px;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        background-color: #fff;
        z-index: 1;
        transition: border-color 0.1s cubic-bezier(0.71, -0.46, 0.29, 1.46),
          background-color 0.1s cubic-bezier(0.71, -0.46, 0.29, 1.46);
      }
      .is_checked {
        background-color: #3f69f9;
        border-color: #3f69f9;
        i {
          position: absolute;
          transform: scale(0.7);
          top: -3px;
          left: 0px;
          font-size: 14px;
          color: #fff;
        }
      }
    }
    .style_exmp {
      display: inline-block;
      width: 30px;
      height: 16px;
      margin-left: 10px;
    }
    .select {
      display: flex;
      position: relative;
      overflow: hidden;
      width: 130px;
      border: 1px solid #6d7278;
      border-left: 0;
      height: 42px;
      line-height: 40px;
      padding: 0 15px;
      font-size: 14px;
      background-color: #fff;
      border-radius: 0px 4px 4px 0;
      cursor: pointer;
      color: #9d9d9d;
      align-items: center;
      .el-input__icon {
        position: absolute;
        right: 0;
        top: 0;
        &.el-icon-arrow-up {
          transform: rotate(180deg);
        }
        &.on {
          transform: rotate(0);
        }
      }
      // .label-style-name {
      //   display: inline-block;
      //   width: 40px;
      // }
    }
    .select-dropdown {
      position: absolute;
      right: 53px;
      top: -212px;
      overflow: hidden;
      border: 1px solid #3f69f9;
      border-radius: 8px;
      box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05), 0px 8px 10px 1px rgba(0, 0, 0, 0.06),
        0px 5px 5px -3px rgba(0, 0, 0, 0.1);
      width: 130px;
      background: #fff;
      opacity: 0;
      transform: scaleY(0);
      transform-origin: 0 100%;
      transition: all 0.2s;
      z-index: 9999;
      .option {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding-left: 15px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        cursor: pointer;
        .option_name {
          display: inline-block;
          width: 40px;
        }
        &:hover {
          background-color: #ecf2fe;
          color: #3f69f9;
        }
        .iconfont {
          font-size: 12px;
          margin-left: 12px;
        }
      }
      .selected {
        color: #3f69f9;
      }
      &.on {
        transform: scaleY(1);
        opacity: 1;
      }
    }
  }
  &.no-label-input {
    padding-bottom: 0px;
    margin-top: 8px;
    .input-wrap {
      display: block;
      input,
      .main-title {
        width: 50%;
        height: 42px;
        padding: 0 5px;
        font-size: 14px;
        border-radius: 4px;
      }
      .text-num {
        right: 47%;
        color: #183b56;
        top: 0;
        height: 42px;
        line-height: 42px;
      }
      .prompt {
        position: static;
        display: inline-block;
        height: 100%;
        line-height: 42px;
        vertical-align: top;
        margin-left: 20px;
        font-size: 13px;
        color: #6d7278;
      }
      &.disable {
        display: none;
      }
    }
  }
}
::v-deep .el-switch {
  margin-left: 13px;
}
</style>
